<template>
  <div v-if="info != null">
    <div class="tabs" v-if="tab == 1 || has_won">
      <div
        :class="current == 0 ? 'tab-item current' : 'tab-item'"
        v-if="info.show_award_lists || info.is_owner || info.is_admin"
        @click="changeTab(0)"
      >
        中奖名单
      </div>
      <div
        :class="current == 1 ? 'tab-item current' : 'tab-item'"
        v-if="info.show_award_lists || info.is_owner || info.is_admin"
        @click="changeTab(1)"
      >
        我的记录
      </div>
    </div>

    <div class="wrapper" v-if="current == 0">
      <div class="header" v-if="info.is_owner || info.is_admin">
        <div>中奖说明</div>
        <div>
          [邮寄]：中奖者会填写收货信息，根据信息发货后，中奖者会收到发货提醒。
        </div>
        <div class="mt20">
          [中奖者联系微信号/手机号]：中奖者会被分到一个领奖二维码，使用微信扫一扫验证身份，以防冒领和重复领取。
        </div>
      </div>
      <div class="prize-bd" v-for="(item, index) in info.awards" :key="index">
        <div class="prize-item" @click="toAwardsDetail(item)">
          <div class="prize-title">
            <span
              >奖品{{
                info.awards && info.awards.length > 1 ? indexText[item.idx] : ""
              }}：{{ item.title }}</span
            >
            <div>{{ item.desc }}</div>
          </div>
          <img
            class="right-arrow"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220525/d683d3237e2fc36c1f9abb7f0b5c9344.png"
          />
        </div>
      </div>
      <div class="empty"></div>
    </div>

    <div class="wrapper" v-if="current == 1">
      <div
        class="prize-bd my-awards"
        v-for="(item, index) in info.list"
        :key="index"
      >
        <div class="prize-item">
          <div class="prize-title">
            <span
              >奖品{{
                info.awards && info.awards.length > 1 ? indexText[item.idx] : ""
              }}：{{ item.title }}</span
            >
            <div>
              {{ item.t_submit }} 得分:{{ item.score }}分 用时:{{
                item.duration
              }}
            </div>
          </div>
          <div
            class="btn-blue"
            @click="toAddress('', index)"
            v-if="item.deliver_way == 1 && !item.logistics"
          >
            填写收货地址
          </div>
          <div
            class="btn-blue"
            @click="toCash(item.rid)"
            v-else-if="item.status == 0"
          >
            联系发起人
          </div>
          <div
            class="btn-blue"
            @click="toAddress(item.logistics, index)"
            v-else-if="item.status == 1"
          >
            等待发货
          </div>
          <div
            class="btn-blue"
            @click="toAddress(item.logistics, index)"
            v-else-if="item.status == 3"
          >
            已发货
          </div>
          <div
            class="btn-blue"
            @click="toCash(item.rid)"
            v-else-if="item.status == 2"
          >
            已兑奖
          </div>
        </div>
      </div>
      <div class="no-data" v-if="my_awards.length == 0">无中奖记录</div>
      <div class="empty"></div>
    </div>

    <div class="footer" v-if="(info.is_owner || info.is_admin) && current == 0">
      <div
        class="btn btn-ok"
        v-if="info.is_owner || info.is_admin"
        v-clipboard:copy="baseUrl + decodeURIComponent(info.link)"
        v-clipboard:success="onCopy"
      >
        导出中奖名单
      </div>
    </div>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import { reLogin } from "@/utils/common";
import { Toast } from "vant";
import {
  getToken,
  formatDate,
  formatMinute,
  setShareInfo
} from "@/utils/common";
import NavBar from "@/components/navbar";
import api from "@/utils/api";

export default {
  components: { NavBar },
  data() {
    return {
      tab: 1,
      info: null,
      page: 1,
      current: 1,
      my_awards: [],
      indexText: "一二三四五六七八九十",
      baseUrl: api.questionBaseUrl + "/xcx"
    };
  },
  methods: {
    toCash(rid) {
      this.$router.push({ name: "awardsCash", query: { rid: rid } });
    },
    getAddress(e) {
      Toast("请前往微信小程序填写收货地址");
    },
    toAddress(logistics, index) {
      let { awards } = this.info;
      let item = this.my_awards[index]
      let name = item.title;
      let idx = item.idx;
      let title = `${awards && awards.length > 1 ? this.indexText[idx] + '等奖' : '奖品'}：${name}`;
      if(!logistics) {
        logistics = {};
      }
      localStorage.setItem("logistics", JSON.stringify({
        ...logistics, title, qid: this.qid
      }));
      this.$router.push({ name: "awardsAddress" });
    },
    toAwardsDetail(item) {
      this.$router.push({
        name: "awardsDetail",
        query: {
          qid: this.qid,
          award_id: item.award_id,
          title: item.title,
          deliver_way: item.deliver_way
        }
      });
    },
    onCopy() {
      Toast("下载链接已经复制，请在浏览器中去下载");
    },
    changeTab(index) {
      this.current = index * 1;
      if (index == 0) this.getAwardList();
      else {
        this.page = 1;
        this.getMyAwards();
      }
    },
    getAwardList() {
      let param = {
        qid: this.qid,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v2/award/list", param).then(res => {
        if (res.sta == 0) {
          let d = res.data;
          this.info = d;
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    getMyAwards() {
      let param = {
        qid: this.qid,
        access_token: getToken(),
        count: 999,
        page: 1
      };
      questionOnly.get("/xcx/ques/v2/award/user/mine", param).then(res => {
        if (res.sta == 0) {
          let d = res.data;
          for (let i in d.list) {
            let item = d.list[i];
            item.t_submit = formatDate(
              item.t_submit * 1000,
              "yyyy-MM-dd HH:mm"
            );
            item.duration = formatMinute(item.duration);
          }
          this.info = d;
          this.my_awards = d.list;
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  mounted() {
    let { tab = 0, qid } = this.$route.query;
    this.qid = qid;
    this.current = tab * 1;
    if (tab == 0) {
      this.getAwardList();
    } else {
      this.getMyAwards();
    }
    setShareInfo(false);
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.tabs {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid #e0e0e0;
}
.tab-item {
  flex: 1;
  height: rem(80);
  line-height: rem(80);
  text-align: center;
  font-size: rem(30);
  color: #999;
}
.tab-item.current {
  position: relative;
  color: #1890ff;
}
.tab-item.current::before {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  content: "";
  width: rem(120);
  height: rem(6);
  border-radius: rem(10);
  background-color: #1890ff;
}

.wrapper {
  overflow: hidden;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
}
.header {
  font-size: rem(26);
  color: #666;
  padding: rem(30);
}
.header .mt20 {
  margin-top: rem(20);
}
.prize-bd {
  background: #fff;
  margin-bottom: rem(20);
  margin-top: rem(20);
}
.empty {
  height: rem(130);
  width: 100%;
}

.right-arrow {
  width: rem(16);
  height: rem(25);
}
.prize-title {
  font-size: rem(30);
  max-width: rem(620);
}
.my-awards .prize-title {
  max-width: rem(480);
}
.prize-title span {
  display: block;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: rem(8);
}
.prize-title div {
  color: #999;
  font-size: rem(26);
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prize-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: rem(145);
  padding: 0 rem(30);
}
.prize-item.border-top {
  border-top: 2px solid #e0e0e0;
}
.prize-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.avatar {
  width: rem(70);
  height: rem(70);
  border-radius: 50%;
  margin-right: rem(20);
}
.prize-body .name {
  font-size: rem(28);
  line-height: rem(42);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: rem(480);
}
.time {
  font-size: rem(26);
  color: #999;
  line-height: rem(35);
}
.score-box {
  text-align: center;
}
.score {
  font-size: rem(32);
  font-weight: 900;
  color: #1890ff;
  line-height: rem(48);
}
.duration {
  font-size: rem(24);
  color: #999;
  line-height: rem(36);
  width: rem(102);
}

.no-data {
  line-height: rem(180);
  text-align: center;
  color: #999;
  font-size: rem(30);
}

.footer {
  position: fixed;
  bottom: 0;
  height: rem(130);
  background: #fff;
  border-top: 2px solid #eee;
  display: flex;
  align-items: center;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
  left: auto;
  width: 100%;
  max-width: 500px;
  z-index: 999;
}
.footer .btn {
  width: rem(690);
  height: rem(90);
  line-height: rem(90);
  border-radius: rem(10);
  background: #f6f6f6;
  text-align: center;
  margin-left: rem(30);
  font-size: rem(34);
  color: #666;
}
.footer .btn-ok {
  background: #1890ff;
  color: #fff;
}

.btn-blue {
  position: absolute;
  top: rem(30);
  right: rem(30);
  width: rem(180);
  height: rem(48);
  line-height: rem(48);
  color: #fff;
  text-align: center;
  font-size: rem(24);
  background: #1890ff;
  border-radius: rem(4);
}
</style>



// WEBPACK FOOTER //
// src/pages/award/list.vue